import React from 'react';

// ─── Stage colors matched to Flutter AuraColors ───────────────────────────
// stageLost = wine (#8A2A3A) · low_budget = saffron · dead = slate

type LostReason = 'dead' | 'low_budget' | 'competitor';

interface LostReasonBadgeProps {
  reason: LostReason | string;
  competitorName?: string | null;
}

const REASON_CONFIG: Record<LostReason, { label: string; bg: string; color: string }> = {
  dead: {
    label: 'Dead — 5 missed',
    bg: 'rgba(122,161,181,0.15)',   // stageCold (#7AA1B5) at 15% opacity
    color: '#4A728A',
  },
  low_budget: {
    label: 'Lost — Budget',
    bg: 'var(--saffron-50, #FBF3DF)',
    color: 'var(--saffron-600, #B87A2E)',
  },
  competitor: {
    label: 'Lost — Competitor',   // overridden with name below
    bg: 'rgba(138,42,58,0.12)',    // wine at 12%
    color: '#8A2A3A',
  },
};

export function LostReasonBadge({ reason, competitorName }: LostReasonBadgeProps) {
  const cfg = REASON_CONFIG[reason as LostReason] ?? REASON_CONFIG.dead;

  let label = cfg.label;
  if (reason === 'competitor' && competitorName) {
    const name = competitorName.length > 14 ? competitorName.slice(0, 12) + '…' : competitorName;
    label = `Lost — ${name}`;
  }

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        borderRadius: '9999px',
        padding: '2px 8px',
        fontSize: '10px',
        fontWeight: 600,
        lineHeight: 1.4,
        background: cfg.bg,
        color: cfg.color,
        border: `1px solid ${cfg.color}33`,
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </span>
  );
}
